import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.8002 10.4004L8.0002 5.60039L3.2002 10.4004", stroke: "#2C2D32", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrow);
export default ForwardRef;
